export default __webpack_public_path__ + "static/media/happy-people.dd3be242.jpg";